import { PaginationProps } from '@/trio-ui/Pagination/Pagination.component';
import { LocalStorageItemKeys, ValuesWithLabel } from '@/types';
import { fieldsAndFriendlyLabelsList, sortByGroupOptions } from './TalentPoolList.constants';

type PaginationData = Omit<PaginationProps, 'onChangeRecordsPerPage' | 'onChangePageHandler'>;

export const setPaginationDataToLocalStorage = (newPaginationData: PaginationData): void => {
  window.localStorage.setItem(
    LocalStorageItemKeys.CANDIDATE_TABLE_PAGINATION,
    JSON.stringify(newPaginationData)
  );
};

export const getPaginationDataFromLocalStorage = (): PaginationData | null => {
  const paginationData = window.localStorage.getItem(
    LocalStorageItemKeys.CANDIDATE_TABLE_PAGINATION
  );

  if (paginationData) {
    const parsedPaginationData = JSON.parse(paginationData);
    return parsedPaginationData;
  }

  return null;
};

export const getSortByOptions = (): ValuesWithLabel[] => {
  const formatSortByOptions = ([value, label]: string[]): ValuesWithLabel => ({ value, label });
  const isFieldOnSortOptions = ([key]: string[]): boolean => sortByGroupOptions.includes(key);

  const sortByOptionsFiltered = fieldsAndFriendlyLabelsList.filter(isFieldOnSortOptions);
  const sortByOptionsFormatted = sortByOptionsFiltered.map(formatSortByOptions);

  return sortByOptionsFormatted;
};
